import React from 'react';

function Warning({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default Warning;
